const getResponseMessage = (data) => {
	if (typeof data === 'string') return data
	return data?.message || data?.error || data?.detail || ''
}

const getApiErrorMessage = (error, fallbackMessage = 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง') => {
	const status = error?.response?.status
	const responseMessage = getResponseMessage(error?.response?.data)

	if (responseMessage) return responseMessage
	if (!error?.response) {
		if (error?.message && error.message !== 'Network Error') return error.message
		return 'ไม่สามารถเชื่อมต่อเซิร์ฟเวอร์ได้ กรุณาตรวจสอบอินเทอร์เน็ตแล้วลองใหม่'
	}

	switch (status) {
		case 400:
			return 'ข้อมูลที่ส่งไม่ถูกต้อง กรุณาตรวจสอบแล้วลองใหม่'
		case 401:
			return 'เซสชันหมดอายุ กรุณาเข้าสู่ระบบใหม่'
		case 404:
			return 'ไม่พบ API หรือฟีเจอร์นี้ยังไม่เปิดใช้งาน'
		case 500:
			return 'ระบบขัดข้องชั่วคราว กรุณาลองใหม่อีกครั้ง'
		default:
			return fallbackMessage
	}
}

export { getApiErrorMessage }
